import React from "react";
import {useGLTF} from "@react-three/drei";

/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

export function Model(props) {
    const {nodes, materials} = useGLTF("/cartoony.glb");

    materials.black.color.set("#000000");
    materials.hoodie.color.set("#10c743");
    materials.pants.color.set("#1414c6");
    materials.bodySkin.color.set("#ffe6cc");
    materials.grey.color.set("#808080");

    return (
        <group {...props} dispose={null}>
            <primitive object={nodes.mixamorigHips}/>
            <primitive object={nodes.Ctrl_Master}/>
            <primitive object={nodes.Ctrl_ArmPole_IK_Left}/>
            <primitive object={nodes.Ctrl_Hand_IK_Left}/>
            <primitive object={nodes.Ctrl_ArmPole_IK_Right}/>
            <primitive object={nodes.Ctrl_Hand_IK_Right}/>
            <primitive object={nodes.Ctrl_Foot_IK_Left}/>
            <primitive object={nodes.Ctrl_LegPole_IK_Left}/>
            <primitive object={nodes.Ctrl_Foot_IK_Right}/>
            <primitive object={nodes.Ctrl_LegPole_IK_Right}/>
            <skinnedMesh
                name="arms"
                geometry={nodes.arms.geometry}
                material={materials.bodySkin}
                skeleton={nodes.arms.skeleton}
            />
            <skinnedMesh
                name="hair"
                geometry={nodes.hair.geometry}
                material={materials.black}
                skeleton={nodes.hair.skeleton}
            />
            <skinnedMesh
                name="Cylinder003"
                geometry={nodes.Cylinder003.geometry}
                material={materials.hoodie}
                skeleton={nodes.Cylinder003.skeleton}
            />
            <skinnedMesh
                name="Cylinder003_1"
                geometry={nodes.Cylinder003_1.geometry}
                material={materials.grey}
                skeleton={nodes.Cylinder003_1.skeleton}
            />
            <skinnedMesh
                name="legs"
                geometry={nodes.legs.geometry}
                material={materials.bodySkin}
                skeleton={nodes.legs.skeleton}
            />
            <skinnedMesh
                name="pants"
                geometry={nodes.pants.geometry}
                material={materials.pants}
                skeleton={nodes.pants.skeleton}
            />
            <skinnedMesh
                name="mesh016"
                geometry={nodes.mesh016.geometry}
                material={materials.brown}
                skeleton={nodes.mesh016.skeleton}
            />
            <skinnedMesh
                name="mesh016_1"
                geometry={nodes.mesh016_1.geometry}
                material={materials.black}
                skeleton={nodes.mesh016_1.skeleton}
            />
            <skinnedMesh
                name="mesh016_2"
                geometry={nodes.mesh016_2.geometry}
                material={materials.white}
                skeleton={nodes.mesh016_2.skeleton}
            />
            <skinnedMesh
                name="mesh016_3"
                geometry={nodes.mesh016_3.geometry}
                material={materials.lightYellow}
                skeleton={nodes.mesh016_3.skeleton}
            />
            <skinnedMesh
                name="mesh016_4"
                geometry={nodes.mesh016_4.geometry}
                material={materials.grey}
                skeleton={nodes.mesh016_4.skeleton}
            />
            <skinnedMesh
                name="head"
                geometry={nodes.head.geometry}
                material={materials.skin}
                skeleton={nodes.head.skeleton}
            />
        </group>
    );
}

useGLTF.preload("/cartoony.glb");
